<template lang="pug">
.custom-service
  .btn(ref="btn" @click="onClick")
    img(src="~assets/custom-service.png")
  
</template>
<script>
import AlipayService from '@/services/AlipayService'
import Hammer from 'hammerjs'
import gsap from 'gsap'
export default {
  name: 'CustomService',
  props: {},
  data() {
    return {
      lastX: 0,
      lastY: 0,
    }
  },
  computed: {},
  methods: {
    init() {
      this.mc = new Hammer(this.$refs.btn)
      this.mc.add(
        new Hammer.Pan({
          direction: Hammer.DIRECTION_ALL,
          threshold: 0,
        })
      )
      this.mc.on('pan', this.onDrag)

      this.lastX = window.innerWidth - 80
      this.lastY = window.innerHeight - 80
      gsap.set(this.$refs.btn, { x: this.lastX, y: this.lastY })
      //this.lastX = this.$refs.btn.getBoundingClientRect().x
      //this.lastY = this.$refs.btn.getBoundingClientRect().y
    },
    onDrag(e) {
      console.log(e.deltaX, e.deltaY)
      let x = this.lastX + e.deltaX
      let y = this.lastY + e.deltaY

      gsap.set(this.$refs.btn, { x: x, y: y })
      //this.$refs.btn.style.transform = `translate3d(${x}px, ${y}px, 0)`
      //this.$refs.btn.style.left = e.deltaX + 'px'
      //this.$refs.btn.style.top = e.deltaY + 'px'
      if (e.isFinal) {
        this.lastX = x
        this.lastY = y
        this.snap()
      }
    },
    snap() {
      let snapGap = 60
      let rect = this.$refs.btn.getBoundingClientRect()
      let top = rect.y
      let left = rect.x
      console.log('!!!!!!!', top, left)
      let xmin = Math.min(left, window.innerWidth - left)
      let ymin = Math.min(top, window.innerHeight - top)
      if (xmin < ymin) {
        if (left > window.innerWidth - left) {
          left = window.innerWidth - snapGap
        } else {
          left = snapGap
        }
      } else {
        if (top > window.innerHeight - top) {
          top = window.innerHeight - snapGap
        } else {
          top = snapGap
        }
      }
      left -= rect.width / 2
      top -= rect.height / 2
      this.lastX = left
      this.lastY = top
      console.log(xmin, ymin, left, top)
      gsap.to(this.$refs.btn, {
        x: left,
        y: top,
        duration: 0.5,
        ease: 'power2',
      })
    },

    onClick() {
      console.log('onclick')
      AlipayService.sendEvent(AlipayService.Events.CUSTOM_SERVICE)
    },
  },
  mounted() {
    this.init()
  },
}
</script>

<style scoped lang="sass">
@import "src/styles/common.sass"
.custom-service
  pointer-events: none
  +full
  .btn
    pointer-events: all
    transform-origin: center
    position: absolute
    width: pxToRem(80)
    height: pxToRem(80)
    border-radius: pxToRem(40)
    background: white
    z-index: 9999
    top: 0
    left: 0
    border: 2px $cl-blue solid
    +flex-center
    img
      width: 100%
      object-fit: contain
</style>
